$(document).ready(function () {
    $('.js-count-wrapper').each(function(){
        const parent = $(this).find(".js-count");
        const num = $(this).find(".js-count__num");
        let count = parent.children().length;
        num.text(' ' + count + ' ');
    });
});